import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase/app';
import 'firebase/auth';

import Upload from './views/Upload.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'

import MainMenu from './components/MainMenu.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '*',
            redirect: '/upload'
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
        },
        {
            path: '/account',
            name: 'account',
            components: {
                default: function () {
                    return import(/* webpackChunkName: "account" */ './views/Account.vue')
                },
                mainmenu: MainMenu
            },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/newAccount',
            name: 'newAccount',
            components: {
                default: function () {
                    return import(/* webpackChunkName: "newaccount" */ './views/NewAccount.vue')
                },
                mainmenu: MainMenu
            },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/bulk',
            name: 'bulk',
            components: {
                default: function () {
                    return import(/* webpackChunkName: "history" */ './views/UploadBulk.vue')
                },
                mainmenu: MainMenu
            },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/upload',
            name: 'upload',
            components: {
                default: Upload,
                mainmenu: MainMenu
            },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/history',
            name: 'history',
            components: {
                default: function () {
                    return import(/* webpackChunkName: "about" */ './views/History.vue')
                },
                mainmenu: MainMenu
            },
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/verify',
            name: 'verify',
            components: {
                default: function () {
                    return import(/* webpackChunkName: "about" */ './views/Verify.vue')
                },
                mainmenu: MainMenu
            },
            meta: {
                requiresAuth: true
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
    const currentUser = firebase.auth().currentUser;
    if (requiresAuth && !currentUser) {
        next('/login');
    } else if (requiresAuth && currentUser) {
        if (to.name === 'verify' && !('dfmtz' in to.query) && from.name != 'upload') {
            next('/upload');
        } else {
            next();
        }
    } else {
        if (to.name === 'verify' && !('dfmtz' in to.query) && from.name != 'upload') {
            next('/upload');
        } else {
            next();
        }
    }
});

export default router;
